import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import {getBankAccounts} from "../../services/bank_account/bank_account";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import SelectInput from "../system/select";
import FileCell from "../system/fileViewer";
import {Toaster} from "../../helper/Toaster";
import {submitWalletWithdrawal} from "../../services/wallet/wallet";

export function UserWithdrawalForm({withdrawal, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null)
  const [value, setValue] = useState("")
  const [accountId, setAccountId] = useState(null)
  const [description, setDescription] = useState(null);
  const [receipt, setReceipt] = useState(null);
  const [status, setStatus] = useState(false);
  const [initialStatus, setInitialStatus] = useState("");

  useEffect(() => {
    setId(withdrawal?.id ?? null);
    setAccountId(withdrawal?.account_id ?? "");
    setValue(withdrawal?.value ?? "");
    setDescription(withdrawal?.description ?? "");
    setReceipt(withdrawal?.receipt ?? null);
    setInitialStatus(withdrawal?.status ?? "")
    setStatus(
      withdrawal?.status === 'accepted' ? true :
        withdrawal?.status === 'rejected' ? false :
          false
    );
  }, [withdrawal]);

  const save = async () => {

    if (!accountId) {
      Toaster.failure(null,
        <Typography variant="small">
          حساب بانکی خود را انتخاب کنید
        </Typography>);
      return

    }
    const data = {
      value: parseInt(value),
      account_id: parseInt(accountId)
    };

    let result;
    result = await submitWalletWithdrawal(data)
    if (result.status === 200) {
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <>
      <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-grow flex-col gap-4 overflow-y-auto md:overflow-y-scroll">

          <div className="mb-4 border-b">
            <SelectInput
              className="w-full my-4"
              label={Dict("bank_accounts")}
              defaultValue={accountId}
              autoLoadService={getBankAccounts}
              autoLoadRender={({title, card}) => {
                return title + " - " + persianNumberFormat(card)
              }}
              onChange={setAccountId}
            />
          </div>

          {!id &&
            <div className="">
              <Input variant="standard"
                     label="مبلغ برداشت"
                     type="number"
                     placeholder="مبلغ برداشت"
                     onChange={(e) => {
                       setValue(e.target.value)
                     }}
              />
            </div>
          }

          {value &&
            <div className="mb-4">
              {value > 0 &&
                <Typography color="blue-gray" className="flex w-full my-4">
                  {"مبلغ برداشت از کیف پول: " + persianNumberFormat(value, true) + " ریال "}
                </Typography>
              }
            </div>
          }

          {description &&
            <div className="mb-4 border-b">
              <Typography>
                {`توضیحات: ${description}`}
              </Typography>
            </div>
          }

          <div className="mb-4 border-b">
            {receipt &&
              <FileCell fileCode={receipt}/>
            }
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  تایید/رد (درانتظار)
                </Typography>
              }
              checked={status}
              labelProps={{className: "mx-4"}}
            />
          </div>

        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>بستن</span>
          </Button>
          {!id &&
            <Button variant="gradient" color="gray" onClick={save}>
              <span>ذخیره</span>
            </Button>
          }
        </DialogFooter>
      </Dialog>
    </>
  );
}